import styled from "@emotion/styled";
import { TExtendedMeetingRoom } from "apis/meeting-room-device";
import React from "react";
import UI from "@mile-meeting/mile-ui";
import { MeetingRoomHorizontalNonModal } from "uis/non-modal";
import { LinkState } from "./DeviceListItem";

type MeetingRoomItemProps = {
  meetingRoom: TExtendedMeetingRoom;
  linkState: LinkState;
  onHandleArrow: () => void;
  showTable: boolean;
};
const MeetingRoomItem: React.FC<MeetingRoomItemProps> = ({ meetingRoom, onHandleArrow, showTable, linkState }) => {
  const [hoverDetailInfo, setHoverDetailInfo] = React.useState<boolean>(false);
  const meetingRoomItemRef = React.useRef<HTMLDivElement>(null);

  const isErrorMeetingRoom =
    !(linkState === "LINKED") || meetingRoom.meetingRoomDevices.some((device) => device.isBatteryCharging === false);

  const getMeetingRoomDetailModalPosition = () => {
    const rect = meetingRoomItemRef.current?.getBoundingClientRect();
    if ((rect?.bottom ?? 0) + 250 > window.innerHeight) {
      return { top: -220, left: 0 };
    }
    return { top: 26, left: 0 };
  };

  return (
    <Container ref={meetingRoomItemRef}>
      <MeetingRoomInfo>
        <MeetingRoomTitle>
          {isErrorMeetingRoom && <UI.Icon name="warning" size={20} color="var(--alias-color-status-negative)" />}
          <UI.Typography>{meetingRoom.name}</UI.Typography>
          {meetingRoom.meetingRoomIntegration?.integrationProvider === "GOOGLE" && <UI.Icon name="google" size={16} />}
          <DetailInfoContainer
            onMouseEnter={() => setHoverDetailInfo(true)}
            onMouseLeave={() => setHoverDetailInfo(false)}
          >
            <UI.Typography
              type="label01"
              color="var(--alias-color-label-alternative)"
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                padding: "0 4px",
              }}
            >
              상세 정보
            </UI.Typography>
            <MeetingRoomHorizontalNonModal
              meetingRoom={meetingRoom}
              open={hoverDetailInfo}
              position={getMeetingRoomDetailModalPosition()}
            />
          </DetailInfoContainer>
        </MeetingRoomTitle>
        <SubContainer>
          <LocationLabelContainer>
            <UI.Icon name="office" color="var(--alias-color-label-assistive)" size={16} />
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              위치
            </UI.Typography>
          </LocationLabelContainer>
          <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
            {[meetingRoom.building?.name, meetingRoom.floor?.name, meetingRoom.name].join(" - ")}
          </UI.Typography>
        </SubContainer>
      </MeetingRoomInfo>
      <UI.Tag
        label={
          linkState === "UNLINKED_INSIDE"
            ? "내부 미연동"
            : linkState === "UNLINKED_OUTSIDE"
              ? "외부 미연동"
              : linkState === "UNLINKED_BOTH_TABLETS"
                ? "내/외부 미연동"
                : "연동됨"
        }
        color={!(linkState === "LINKED") ? "pink" : "cyan"}
        icon={!(linkState === "LINKED") ? "unLink" : "link"}
        showIcon
      />
      <UI.IconButton.Normal
        icon={showTable ? "chevronUp" : "chevronDown"}
        size={24}
        color="var(--alias-color-label-alternative)"
        onClick={onHandleArrow}
      />
    </Container>
  );
};

export default React.memo(MeetingRoomItem);

const Container = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-alternative);
  gap: 20px;
`;

const MeetingRoomInfo = styled.div`
  display: flex;
  min-width: 240px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

const MeetingRoomTitle = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-items: center;
`;

const DetailInfoContainer = styled.div`
  margin-left: 4px;
  position: relative;
`;

const SubContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const LocationLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
